import { render, staticRenderFns } from "./ManageProfile.vue?vue&type=template&id=54206cfd&"
import script from "./ManageProfile.vue?vue&type=script&lang=js&"
export * from "./ManageProfile.vue?vue&type=script&lang=js&"
import style0 from "./ManageProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports